<div class="utilities">
  <div class="utilities__header">
    <p class="utilities__subtitle">{{ 'utilities.subtitle' | translate }}</p>
  </div>

  <div class="column">
    @for (card of cards; track card.titleKey) {
      <app-card-dashboard
        [title]="card.titleKey | translate"
        [description]="card.descriptionKey | translate"
        [iconClass]="card.iconClass"
        (linkClick)="openCard(card)">
      </app-card-dashboard>
    }
  </div>
</div>
